import React from 'react';
import { ExternalLink, X, AlertTriangle } from 'lucide-react';

interface ExternalLinkModalProps {
  isOpen: boolean;
  url: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ExternalLinkModal: React.FC<ExternalLinkModalProps> = ({
  isOpen,
  url,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onCancel}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6">
        {/* Close button */}
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-black/40 hover:text-black/60 transition-colors"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Icon */}
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-amber-100 mb-4">
          <AlertTriangle className="h-6 w-6 text-amber-600" />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-black mb-2">
          Link Esterno
        </h3>

        {/* Description */}
        <p className="text-sm text-black/60 mb-4">
          Stai per aprire un link esterno in una nuova scheda. Verifica che l'URL sia sicuro prima di procedere.
        </p>

        {/* URL Display */}
        <div className="bg-black/5 rounded-lg p-3 mb-6 break-all">
          <div className="flex items-start gap-2">
            <ExternalLink className="h-4 w-4 text-black/40 mt-0.5 flex-shrink-0" />
            <span className="text-sm text-black/80 font-mono">
              {url}
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2.5 bg-black/5 text-black rounded-lg hover:bg-black/10 transition-colors font-medium"
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2.5 bg-black text-white rounded-lg hover:bg-black/90 transition-colors font-medium flex items-center justify-center gap-2"
          >
            <ExternalLink className="h-4 w-4" />
            Apri Link
          </button>
        </div>
      </div>
    </div>
  );
};
